import { action } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';

export type MailReadingContextSetMessage = {
    mailboxInfo: MailboxInfo;
    conversationId?: string;
    itemId?: string;
    targetWindow?: Window;
};

export const mailReadingContextSetAction: (
    mailboxInfo: MailboxInfo,
    conversationId?: string,
    itemId?: string,
    targetWindow?: Window
) => MailReadingContextSetMessage = action(
    'MAIL_READING_CONTEXT_SET',
    (
        mailboxInfo: MailboxInfo,
        conversationId?: string,
        itemId?: string,
        targetWindow?: Window
    ): MailReadingContextSetMessage => ({ mailboxInfo, conversationId, itemId, targetWindow })
);
